<ng-container *ngIf="returnUrl">
    <div class="back">
        <button mat-stroked-button
                (click)="back()">
            <mat-icon
                    [svgIcon]="'expand_less'"></mat-icon>
        </button>
    </div>
</ng-container>
